export default __webpack_public_path__ + "static/13_19-5d54c24852408d808f3357b8e1887dcd.png";